import { Component, Input, OnInit } from '@angular/core';
import {trigger, state, style, transition, animate} from '@angular/animations';
import { Router } from '@angular/router';
import { UtilsService } from '../shared/utils-service';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
  animations: [
   trigger('slideInOut', [
     state('in', style({
        transform: 'translate(-250px)'
     })),
     state('out', style({
       transform: 'translate(0px)'
     })),
     transition('in => out', animate('400ms ease-in-out')),
     transition('out => in', animate('400ms ease-in-out'))
   ]),
 ]
})
export class NavBarComponent implements OnInit {
@Input() model: any = {};
menuState:string = 'out';
logoutURL : string = this.utils.url+'/ddmfLogin/logout';
	private loggedInUser: any = {};
  routerURL: any = '';
  constructor(private http: Http, private router: Router, private utils: UtilsService) {
  	this.loggedInUser = this.utils._checkSession();
   }

  ngOnInit() {
    //console.log(this.menuState);
  }
  toggleMenu() {
    // 1-line if statement that toggles the value:
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
   // console.log(this.menuState);
  }
  
  changePassword(){
  	this.router.navigateByUrl('/change-password');
  }
  
  logout() {
  var headers = new Headers();
	headers.append('Content-Type', 'application/json');
  this.http.post(this.logoutURL, JSON.stringify({"userId": this.loggedInUser.userId}), { headers: headers } ).subscribe(res => {
  	},
		error => {
     
		});
    sessionStorage.setItem('logged_in_user', '');
    this.router.navigateByUrl('/');
  }

}



// WEBPACK FOOTER //
// ./src/app/nav-bar/nav-bar.component.ts